/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Boundary_Reload_AppInputs */

const en_error_boundary_reload_app = /** @type {(inputs: Error_Boundary_Reload_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload app`)
};

const es_error_boundary_reload_app = /** @type {(inputs: Error_Boundary_Reload_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recargar app`)
};

/**
* | output |
* | --- |
* | "Reload app" |
*
* @param {Error_Boundary_Reload_AppInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const error_boundary_reload_app = /** @type {((inputs?: Error_Boundary_Reload_AppInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Boundary_Reload_AppInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_boundary_reload_app(inputs)
	return es_error_boundary_reload_app(inputs)
});